var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('MainBanner'),_c('Welcome'),_c('WhyChooseUs'),_c('OurServices'),_c('WhatOurCustomerSays'),_c('Form'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }